module.exports = __webpack_public_path__ + "static/img/S05.58cb6a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/S05.jpg
// module id = mn06
// module chunks = 9